import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_result_check",
  "use": "icon-icon_result_check-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\" id=\"icon-icon_result_check\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h80v80H0z\" /><path fill=\"#FFF\" d=\"m33.333 50.573 30.64-30.643 4.717 4.713L33.333 60 12.12 38.787l4.713-4.714z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol